import { Newspaper } from "lucide-react";
import dayjs from "dayjs";
import type { StrapiArticle } from "./types";

interface ArticleFeedRowProps {
  article: StrapiArticle;
  onClick?: () => void;
  // Height policy, set by ArticlesList. The thumbnail sizes itself off the
  // row's height, so the row needs a definite one.
  className?: string;
}

export const ArticleFeedRow = ({
  article,
  onClick,
  className = "",
}: ArticleFeedRowProps) => {
  const dateToDisplay = article.displayPublishDate || article.publishedAt;
  const formattedDate = dayjs(dateToDisplay).fromNow();

  return (
    <div
      className={`flex items-stretch gap-3 rounded-md ${className} ${
        onClick ? "cursor-pointer transition-colors hover:bg-muted" : ""
      }`}
      onClick={onClick}
    >
      <div
        data-testid="article-thumb"
        className="hidden h-full w-auto aspect-4/3 max-w-[38%] shrink-0 overflow-hidden rounded-md @sm:block"
      >
        {article.cover ? (
          <img
            src={article.cover.url}
            alt={article.cover.alternativeText || article.title}
            className="size-full object-cover"
          />
        ) : (
          <div className="flex size-full items-center justify-center">
            <Newspaper className="size-5 text-muted-foreground" />
          </div>
        )}
      </div>

      <div className="flex min-w-0 flex-1 flex-col justify-center gap-1">
        <h3 className="line-clamp-1 text-sm font-semibold">{article.title}</h3>
        <p className="line-clamp-2 text-xs text-muted-foreground">
          {article.description}
        </p>
        <span className="text-xs text-muted-foreground">
          {article.category ? `${article.category.name} · ` : ""}
          {formattedDate}
        </span>
      </div>
    </div>
  );
};
